import { FlowBase, identificationTypes } from "./flow-base";
import Utilities from "../utilities";
import * as events from "../events";

class SFCKE extends FlowBase {

    subscriptionCheckCallFinished = false
    ajaxIdentify() {
        this.logger.info("identify call started", {
            event_type: 'identify_start',
        });
        if (this.metadata["page_attributes-no-identify-sfc"]) {
            this.identifyOnSuccess(this.fakeResponse())
            return
        }
        if (!this.internalCall) {
            this.integrator.customHeIdentifyGetRequestWithAuth({
                return: window.location.origin + window.location.pathname,
            }, "https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn", this.heAuthToken, this.identifyOnSuccess.bind(this), this.identifyOnError.bind(this));
        }
    }

    identifyOnSuccess(response) { // overridable
        if (this.metadata["page_attributes-debug"]) {
            var elemDiv = document.createElement('div');
            elemDiv.innerHTML = '<p style="color: white">' + JSON.stringify(response) + '</p>'
            document.body.appendChild(elemDiv);
        }

        const identified = !!response?.ServiceResponse?.ResponseBody?.Response?.Msisdn;

        this.logger.info("received identify response", {
            event_type: 'identify_response',
            identified: identified
        });

        this.identifyCallFinished = true;
        if (identified) {
            this.identified = true
            this.identity = response.ServiceResponse.ResponseBody.Response.Msisdn
            this.tracker.track(events.IDENTIFY_SUCCESS);

            // check for existing subs here
            const msisdn = response.ServiceResponse.ResponseBody.Response.Msisdn
            const plan = this.plan
            this.integrator.LPCheckSubscriptionRequest({ msisdn, plan }, this.subscriptionCheckOnSuccess.bind(this), this.subscriptionCheckOnFailure.bind(this)) // do nothing on failure, this is just to check if a sub already exists
        } else {
            this.tracker.track(events.IDENTIFY_FAILURE);
            this.identifyBackup()
        }
    }

    identifyOnError(response) { // overridable
        if (this.metadata["page_attributes-debug"]) {
            var elemDiv = document.createElement('div');
            elemDiv.innerHTML = '<p style="color: white">' + JSON.stringify(response) + '</p>'
            document.body.appendChild(elemDiv);
        }

        // this log is for the metrics
        this.logger.info("received identify response", {
            event_type: 'identify_response',
            identified: false
        });
        this.identifyCallFinished = true;

        if (response.header?.responseCode === 403) {
            //just an ID fail
            this.tracker.track(events.IDENTIFY_FAILURE);
        } else {
            this.logger.error('Integrator request failed', {
                response: response
            });
            this.tracker.track(events.IDENTIFY_ERROR);
        }

        this.identifyBackup()
    }

    subscriptionCheckOnSuccess(response) {
        // check for presence of jwt token and if the sub is new or not
        const token = response.access_token
        const newSub = response.new

        if (response.status === 'subscription_in_progress') {
            this.uiControl.showErrorMessage("Subscription is still in progress, please refresh shortly")
            return
        }

        if (token && !newSub) {
            this.redirectToProduct(response.access_token);
            this.redirecting = true
        }
        this.subscriptionCheckCallFinished = true;
    }

    subscriptionCheckOnFailure(response) {
        this.subscriptionCheckCallFinished = true;

        if (response.code != 404) {
            this.logger.error('Integrator request failed', {
                response: response
            });
        }
    }

    sub() {
        this.logger.debug('[Subscribe User] user is identified; attempting subscription', {
            identity: this.identity,
            metadata: this.metadata
        });

        var plan = this.plan;
        const planMap = this.metadata["page_attributes-plan-map"]
        if (planMap) {
            const radioInputValue = this.uiControl.getCheckedRadioInputValue("planOption")
            if (!radioInputValue) {
                //TODO: show error message if user does not select a radio button
                return;
            }
            var plan = planMap[radioInputValue]
        }
        const data = {
            msisdn: this.identity,
            fraud_transaction_id: this.metadata.fraud_transaction_id,
            metadata: this.metadata,
            plan_id: parseInt(plan),
            locale: this.locale,
            tracking_id: this.metadata.event_tracking_id,
            marketing_data: this.metadata,
            subscription_data: this.metadata,
            token: this.metadata.fraud_transaction_id,
        };
        const timeout = 180000 //a 3 minute timeout is needed as MPESA callbacks take a while for us to receive

        this.integrator.LPSubscribeRequest(data, this.subscribeEndpoint, this.subscribeOnSuccess.bind(this), this.subscribeOnError.bind(this), timeout)
    }

    // overidden so we can add extra data to the data layer
    subscribe() {
        this.setInactiveTimeout();
        this.tracker.track(events.FIRST_CLICK)
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'sfc_flow_event',
                sfc_event_name: 'FirstClick',
                sfc_reference: this.event_tracking_id,
                sfc_evina_id: this.metadata.fraud_transaction_id,
            });
        }
        this.setFlowStep(this.flowSteps.CONFIRM)
    }

    // overidden so we can add extra data to the data layer
    confirm() {
        if (!this.consentTickbox || (this.consentTickbox && this.uiControl.controls.consent.consentTickbox.checked)) {
            this.clearInactiveTimeout();
            this.tracker.track(events.SECOND_CLICK)
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'sfc_flow_event',
                    sfc_event_name: 'SecondClick',
                    sfc_reference: this.event_tracking_id,
                    sfc_evina_id: this.metadata.fraud_transaction_id,
                });
            }
            this.handleSubscribe()
        }
    }

    handleSubscriptionFailed(event) {
        this.tracker.track(events.SUBSCRIPTION_FAILED, {
            data: {
                reference: event.reference,
                status_code: event.status_code,
                error_message: event.error,
            }
        });
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'sfc_flow_event',
                sfc_event_name: 'SubscriptionFailed',
                sfc_reference: this.event_tracking_id,
                sfc_evina_id: this.metadata.fraud_transaction_id,
            });
        }
    }

    subscribeUser() {
        if (this.identified) {
            this.setFlowStep(this.flowSteps.SPINNER)
            Utilities.waitForConditionAndExecute(
                this.isThirdPartyCallComplete.bind(this),
                this.sub.bind(this)
            );
        } else {
            if (this.identification == identificationTypes.DEBUG) {
                this.otpValidateSuccess({ "status": "SUCCESS" })
                return
            }
            this.identifyBackup()
        }
    }

    subscribeOnSuccess(response) {
        if (response.status.toLowerCase() === "subscription_in_progress") {
            this.uiControl.showErrorMessage("Subscription is still in progress, please refresh shortly")
            return
        }

        if (response.status.toLowerCase() !== "subscribed") {
            // this shouldn't really occur because we got a 200
            this.subscribeOnError(response)
            return
        }

        // success condition
        if (response.new) {
            this.dispatcher.dispatchEvent(events.SUBSCRIPTION_SUCCEEDED, {
                jwt: response.access_token,
                reference: response.reference,
            });
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'sfc_flow_event',
                    sfc_event_name: 'SubscriptionSucceeded',
                    sfc_reference: this.event_tracking_id,
                    sfc_evina_id: this.metadata.fraud_transaction_id,
                });
            }
        } else {
            this.tracker.track(events.SUBSCRIPTION_EXISTS, {
                data: {
                    reference: response.reference,
                },
            });
            this.redirectToProduct(response.access_token);
        }
    }

    subscribeOnError(response) {
        if (response.reason && response.reason === "insufficient_balance") {
            this.logger.debug(`[Subscribe Error] Flow (${this.name}): insufficent funds`, { "response": response });
            this.setFlowStep(this.flowSteps.SUBSCRIPTION_FAILED);
            this.dispatcher.dispatchEvent(events.SUBSCRIPTION_FAILED, {
                reference: response.reference,
                status_code: response.status_code,
                error: response.message || null,
                response_string: response.response_string || null,
                content_blocked: this.userContentBlocked
            });
            this.uiControl.displayCustomMessage('You have insufficient funds. Kindly top-up to enjoy the service.');
        } else {
            this.logger.error(`[Subscribe Error] Flow (${this.name}): received error from integrator`, { "response": response });
            this.setFlowStep(this.flowSteps.SUBSCRIPTION_FAILED);
            this.dispatcher.dispatchEvent(events.SUBSCRIPTION_FAILED, {
                reference: response.reference,
                status_code: response.code,
                error: response.reason,
                response_string: response.response_string || null,
            });
            this.uiControl.showErrorMessage('INTEGRATOR_ERROR', 'Retry');
        }
    }

    fakeResponse() {
        return {
            "ServiceResponse": {
                "ResponseBody": {
                    "Response": {
                        "Msisdn": "123456789"
                    }
                }
            }
        }
    }

    overridableInit() {
        this.thirdPartyCallComplete = false;
        window.setTimeout(this.setThirdPartyCallComplete.bind(this), 20000);
        document.addEventListener('EvinaMsisdnSaved', (event) => {
            this.thirdPartyCallComplete = true;
        }, false);
    }

    setThirdPartyCallComplete() {
        this.thirdPartyCallComplete = true;
    }

    isThirdPartyCallComplete() {
        return this.thirdPartyCallComplete && this.subscriptionCheckCallFinished && !this.redirecting;
    }
}

const SFCKEFlow = new SFCKE('SFC KE', identificationTypes.AJAX, {
    subscribeClick: true,
    identifyTimeout: 20,
    exitHandlerEnabled: true,
    subscribeEndpoint: 'subscribe/token'
})
window.FlowModule = SFCKEFlow;
